import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ParkAutoContract from "./tabs/ParkAutoContract";
import ParkAutoAssignation from "./tabs/ParkAutoAssignation";
import ParkAutoData from "./tabs/ParkAutoData";
import { Tabs } from "antd";
import ParkAuto from "../../services/api/ParkAuto";
import { useParams } from "react-router-dom";
import { showError } from "../../utils/utilities";
import { get } from "lodash";
import { setSection } from "../../redux/ducks/Section";
import { useDispatch } from "react-redux";
import { initFilters } from "../../redux/ducks/Filters";

const ParkAutoDetail = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const [state, setState] = useState({
    parkAutoDetail: {},
    refreshParkAuto: false,
  });
  useEffect(() => {
    dataList();
  }, []);
  useEffect(() => {
    // necessary for refresh by tab
    dataList();
  }, [state.refreshParkAuto]);
  useEffect(() => {
    dispatch(
      setSection({
        section: {
          title: state.parkAutoDetail.plate,
        },
      })
    );
  }, [state.parkAutoDetail]);
  const dataList = async () => {
    let parkAutoDetail = {};
    setState((prevState) => ({ ...prevState, loading: true }));
    const { data, error } = await ParkAuto.getParkAuto(params.carId);
    if (!error && data) {
      parkAutoDetail = data;
    } else {
      showError(get(error, "messageCode", "ER000"));
    }
    setState((prevState) => ({ ...prevState, loading: false, parkAutoDetail }));
  };
  const handleChange = () => {
    dispatch(initFilters());
  };

  return (
    <Tabs
      className="PFtabs"
      onChange={handleChange}
      items={[
        {
          label: t(`parkAuto.tabs.data`),
          key: "data",
          children: <ParkAutoData parkAuto={state.parkAutoDetail} setFatherState={setState} fatherState={state} />,
        },
        {
          label: t(`parkAuto.tabs.contract`),
          key: "contract",
          children: <ParkAutoContract parkAuto={state.parkAutoDetail} />,
        },
        {
          label: t(`parkAuto.tabs.assignation`),
          key: "assignation",
          children: <ParkAutoAssignation parkAuto={state.parkAutoDetail} />,
        },
      ]}
    />
  );
};

export default ParkAutoDetail;
